export const roles = [
  {
    id: 0,
    auth: "client",
    description: "Users with a client role can view their companys data",
  },
  {
    id: 1,
    auth: "user",
    description: "A user role allows users to view their data",
  },
  { id: 2, auth: "admin", description: "An admin is allowed full access data" },
  {
    id: 3,
    auth: "owner",
    description: "An owner is allowed full access and account settings",
  },
  { id: 4, auth: "superAdmin", hide: true, description: "" },
];

export function renderMenuItems(arr, userAuthority) {
  const menuItems = arr;

  // Add safety check for userAuthority
  if (!userAuthority) {
    // If no userAuthority, only return items that don't require authority or have authority as true
    return menuItems.filter((i) => {
      if (typeof i.authority === "boolean") {
        return i.authority;
      }
      // If no authority specified, allow access
      return !i.authority;
    });
  }

  return menuItems.filter((i) => {
    if (typeof i.authority === "boolean") {
      return i.authority;
    }
    if (!i.authority) {
      return true;
    }

    const verifyAuthority = verifyAuth(i.authority, userAuthority);
    return verifyAuthority.type === "success";
  });
}

export function verifyAuth(currentAuth, userAuthority) {
  // Add validation to prevent undefined/null errors
  if (!currentAuth || !userAuthority) {
    return {
      type: "error",
      message: "Missing authentication parameters",
    };
  }

  // Ensure parameters are arrays or convert strings to arrays
  const currentAuthArray = Array.isArray(currentAuth)
    ? currentAuth
    : [currentAuth];
  const userAuthorityArray = Array.isArray(userAuthority)
    ? userAuthority
    : [userAuthority];

  const routeAuth = roles.filter((item) =>
    currentAuthArray.includes(item.auth)
  )[0];
  const userAuth = roles.filter((item) =>
    userAuthorityArray.includes(item.auth)
  )[0];

  if (!userAuth)
    return {
      type: "error",
      message: "User does not have permission",
    };

  if (!routeAuth)
    return {
      type: "error",
      message: "Invalid route authority",
    };

  if (userAuth.id < routeAuth.id) {
    return {
      type: "error",
      message: "User does not have permission",
    };
  }

  if (userAuth.id >= routeAuth.id) {
    return {
      type: "success",
      message: "User has permission",
    };
  }
}
